export const BLOG_TYPE_KEY = 'blog';
export const BLOG_TYPE_NOUN_KEY = 'categories.blog_post';
export const BLOG_TYPE_UNPUBLISH_CHANGES = 'blogUnpublishedChanges';